import React, { useState } from 'react';
import { generateQRCode, copyURLToClipboard } from '../../utils/qrCodeUtils';
import style from './QRCodeGenerator.module.scss';

interface QRCodeGeneratorProps {
	campaignUrl: string;
	campaignTitle: string;
	autoGenerate?: boolean;
}

export default function QRCodeGenerator({ campaignUrl, campaignTitle, autoGenerate = false }: QRCodeGeneratorProps): JSX.Element {
	const [qrCodeData, setQrCodeData] = useState<string | null>(null);
	const [isGenerating, setIsGenerating] = useState(false);
	const [copySuccess, setCopySuccess] = useState(false);

	// Auto-generate QR code on mount if autoGenerate is true
	React.useEffect(() => {
		if (autoGenerate && !qrCodeData) {
			handleGenerateQRCode();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [autoGenerate]);

	const handleGenerateQRCode = async () => {
		setIsGenerating(true);
		try {
			const qrData = await generateQRCode(campaignUrl);
			setQrCodeData(qrData);
		} catch (error) {
			console.error('Failed to generate QR code:', error);
			alert('Failed to generate QR code. Please try again.');
		} finally {
			setIsGenerating(false);
		}
	};

	const handleCopyURL = async () => {
		const success = await copyURLToClipboard(campaignUrl);
		if (success) {
			setCopySuccess(true);
			setTimeout(() => setCopySuccess(false), 2000);
		}
	};

	return (
		<div className={style.QRCodeContainer}>
			<div className={style.QRContent}>
				{/* <h3>Campaign QR Code & URL</h3> */}

				<div className={style.URLSection}>
					<label>Campaign URL:</label>
					<div className={style.URLBox}>
						<input type="text" value={campaignUrl} readOnly />
						<button onClick={handleCopyURL} className={style.CopyButton}>
							{copySuccess ? '✓ Copied!' : 'Copy'}
						</button>
					</div>
				</div>

				{!qrCodeData ? (
					<div className={style.GeneratingMessage}>
						{isGenerating ? 'Generating QR Code...' : 'Click Generate to create QR Code'}
					</div>
				) : (
					<div className={style.QRCodeDisplay}>
						<img src={qrCodeData} alt="Campaign QR Code" />
					</div>
				)}
			</div>
		</div>
	);
}
